import styled from 'styled-components'
import { formatSeconds } from './helpers'

const PlaybuttonContainer = styled.div`
  border-radius: 80px;
  @keyframes cliparapulse4 {
    0% {
      box-shadow: 0 0 0 0 ${(props) => props.playButtonColor};
    }
    100% {
      box-shadow: 0 0 0 8px #fbb32f01;
    }
  }
  display: block;
  -webkit-transform: translateZ(0);
  fill: none !important;
  position: absolute;
  ${(props) => props.animate && `animation: cliparapulse4 1500ms infinite;`}
  z-index: 2;
  ${(props) => {
    if (props.widgetPlayButtonPosition === 'BOTTOM_LEFT') {
      return `bottom: 16px; left: 16px;`
    }
    if (props.widgetPlayButtonPosition === 'BOTTOM_RIGHT') {
      return `bottom: 16px; right: 16px;`
    }
    return ` top: 50%; left: 50%; transform: translate(-50%, -50%);`
  }}
  ${(props) => {
    if (props.widgetPlayButtonSize === 'SMALL') {
      return `width: 40px !important; height: 40px !important;`
    }
    if (props.widgetPlayButtonSize === 'MEDIUM') {
      return `width: 60px !important; height: 60px !important;`
    }
    return `width: 80px !important; height: 80px !important;`
  }}
  svg {
    ${(props) => {
      if (props.widgetPlayButtonSize === 'SMALL') {
        return `width: 40px !important; height: 40px !important;`
      }
      if (props.widgetPlayButtonSize === 'MEDIUM') {
        return `width: 60px !important; height: 60px !important;`
      }
      return `width: 80px !important; height: 80px !important;`
    }}
  }
`

const PlayButton = styled.svg`
  display: block;
  -webkit-transform: translateZ(0);
  fill: none !important;
  width: ${(props) => props.width}px !important;
  height: ${(props) => props.height}px !important;
  position: relative;
  z-index: 2;

  border-radius: 60px;
  cursor: pointer;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const SquarePlayButton = styled.div`
  z-index: 2;
  @keyframes cliparapulse5 {
    0% {
      box-shadow: 0 0 0 0 ${(props) => props.playButtonColor};
    }
    100% {
      box-shadow: 0 0 0 8px #fbb32f01;
    }
  }
  position: absolute;
  ${(props) => {
    if (props.widgetPlayButtonPosition === 'BOTTOM_LEFT') {
      return `bottom: 16px; left: 16px;`
    }
    if (props.widgetPlayButtonPosition === 'BOTTOM_RIGHT') {
      return `bottom: 16px; right: 16px;`
    }
    return `top: 50%; left: 50%; transform: translate(-50%, -50%);`
  }}
  ${(props) => props.animate && `animation: cliparapulse5 1500ms infinite;`}
  background-color: ${(props) => props.playButtonColor};
  width: ${(props) => {
    if (props.widgetPlayButtonSize === 'SMALL') {
      return '40px'
    }
    if (props.widgetPlayButtonSize === 'MEDIUM') {
      return '60px'
    }
    return '80px'
  }} !important;
  height: ${(props) => {
    if (props.widgetPlayButtonSize === 'SMALL') {
      return '21px'
    }
    if (props.widgetPlayButtonSize === 'MEDIUM') {
      return '32px'
    }
    return '43px'
  }} !important;
  svg {
    ${(props) => {
      if (props.widgetPlayButtonSize === 'SMALL') {
        return `width: 10px !important; height: 10px !important;`
      }
      if (props.widgetPlayButtonSize === 'MEDIUM') {
        return `width: 16px !important; height: 16px !important;`
      }
      return `width: 20px !important; height: 20px !important;`
    }}
  }
  border-radius: 4px !important;
  display: flex;
  align-items: center;
  justify-content: center;
`

const DurationContainer = styled.div`
  position: absolute;
  z-index: 2;
  ${(props) => {
    if (props.widgetPlayButtonPosition === 'BOTTOM_LEFT') {
      return `bottom: 16px; left: 16px;`
    }
    if (props.widgetPlayButtonPosition === 'BOTTOM_RIGHT') {
      return `bottom: 16px; right: 16px;`
    }
    return `top: 50%; left: 50%; transform: translate(-50%, -50%);`
  }}
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    ${(props) => {
      if (props.widgetPlayButtonSize === 'SMALL') {
        return `width: 13px !important; height: 13px !important;`
      }
      if (props.widgetPlayButtonSize === 'MEDIUM') {
        return `width: 15px !important; height: 15px !important;`
      }
      return `width: 17px !important; height: 17px !important;`
    }}
  }
`

const DurationText = styled.p`
  ${(props) => {
    if (props.widgetPlayButtonSize === 'SMALL') {
      return `font-size: 14px !important;`
    }
    if (props.widgetPlayButtonSize === 'MEDIUM') {
      return `font-size: 16px !important;`
    }
    return `font-size: 18px !important;`
  }}
  color: white !important;
  font-weight: 600 !important;
  margin: 0px !important;
  padding: 0px !important;
  line-height: 14px !important;
  margin-left: 8px !important;
`

const InlinePlayButton = ({ campaign, pbWidth, video }) => {
  if (campaign.widgetPlayButtonStyle === 'FILLED') {
    return (
      <PlaybuttonContainer
        widgetPlayButtonSize={campaign.widgetPlayButtonSize}
        animate={campaign.playButtonAnimation}
        playButtonColor={campaign.playButtonColor || '#333333'}
        widgetPlayButtonPosition={campaign.widgetPlayButtonPosition}
        width={pbWidth}
        height={pbWidth}
      >
        <PlayButton
          animate={campaign.playButtonAnimation}
          playButtonColor={campaign.playButtonColor || '#333333'}
          width={pbWidth}
          height={pbWidth}
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="30" cy="30" r="30" fill={campaign.playButtonColor || '#333333'} />
          <path
            d="M45 28.268C46.3333 29.0378 46.3333 30.9623 45 31.7321L24 43.8564C22.6667 44.6262 21 43.664 21 42.1244L21 17.8756C21 16.336 22.6667 15.3738 24 16.1436L45 28.268Z"
            fill="white"
          />
        </PlayButton>
      </PlaybuttonContainer>
    )
  }

  if (campaign.widgetPlayButtonStyle === 'BOX') {
    return (
      <SquarePlayButton
        widgetPlayButtonSize={campaign.widgetPlayButtonSize}
        animate={campaign.playButtonAnimation}
        playButtonColor={campaign.playButtonColor || '#333333'}
        widgetPlayButtonPosition={campaign.widgetPlayButtonPosition}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.677 7.43164C16.1077 7.68008 16.1077 8.31992 15.677 8.56836L2.93823 15.9164C2.51787 16.1588 2 15.8451 2 15.348V0.652003C2 0.154881 2.51787 -0.158835 2.93823 0.0836401L15.677 7.43164Z"
            fill={'white'}
          />
        </svg>
      </SquarePlayButton>
    )
  }

  if (campaign.widgetPlayButtonStyle === 'DURATION') {
    return (
      <DurationContainer
        widgetPlayButtonSize={campaign.widgetPlayButtonSize}
        alignItems="center"
        justifyContent="center"
        width="auto"
        widgetPlayButtonPosition={campaign.widgetPlayButtonPosition}
      >
        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.9673 6.50268C12.3442 6.72007 12.3442 7.27993 11.9673 7.49732L0.820953 13.9268C0.453137 14.139 0 13.8645 0 13.4295V0.570503C0 0.135521 0.453137 -0.13898 0.820954 0.0731851L11.9673 6.50268Z"
            fill="white"
          />
        </svg>
        <DurationText widgetPlayButtonSize={campaign.widgetPlayButtonSize}>{formatSeconds(video.duration)}</DurationText>
      </DurationContainer>
    )
  }

  return (
    <PlaybuttonContainer
      widgetPlayButtonSize={campaign.widgetPlayButtonSize}
      animate={campaign.playButtonAnimation}
      playButtonColor={campaign.playButtonColor || '#333333'}
      widgetPlayButtonPosition={campaign.widgetPlayButtonPosition}
      width={pbWidth}
      height={pbWidth}
    >
      <PlayButton
        animate={campaign.playButtonAnimation}
        playButtonColor={campaign.playButtonColor || '#333333'}
        width={pbWidth}
        height={pbWidth}
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="30" cy="30" r="28.5" stroke={campaign.playButtonColor || '#333333'} strokeWidth="3" />
        <path
          d="M46.1097 29.2683C47.4431 30.0381 47.4431 31.9626 46.1097 32.7324L24.9451 44.9518C23.6118 45.7216 21.9451 44.7594 21.9451 43.2198L21.9451 18.781C21.9451 17.2414 23.6118 16.2791 24.9451 17.0489L46.1097 29.2683Z"
          fill={campaign.playButtonColor || '#333333'}
        />
      </PlayButton>
    </PlaybuttonContainer>
  )
}

export default InlinePlayButton
